import { Chip } from "@mui/material";
import { AtTagNoteProps } from "../at-tag.types";
import {
  ERROR,
  INFO,
  PRIMARY,
  SUCCESS,
  SURFACE,
  WARNING,
} from "../../../../utils";
import { cva } from "class-variance-authority";

export const TagNote = ({ color: type, text }: AtTagNoteProps) => {
  return <Chip label={text} className={variant({ type })} />;
};

const variant = cva("!text-xs !font-semibold", {
  variants: {
    type: {
      [ERROR]: "!bg-error-50 !text-error-700",
      [SUCCESS]: "!bg-success-50 !text-success-800",
      [INFO]: "!bg-info-50 !text-info-700",
      [WARNING]: "!bg-warning-50 !text-warning-800",
      [PRIMARY]: "!bg-primary-50 !text-primary-500",
      [SURFACE]: "!bg-surface-50 !text-surface-400",
    },
  },
  defaultVariants: {
    type: SURFACE,
  },
});
